import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getConfiguracoes } from '../lib/supabase'
import Loading from '../components/Loading'

function Secao({ titulo, children }) {
  return (
    <div style={{ marginBottom: '32px' }}>
      <h3 style={{
        fontSize: '16px',
        color: 'var(--cor-principal)',
        marginBottom: '10px',
        paddingBottom: '8px',
        borderBottom: '1px solid var(--cor-borda)',
      }}>
        {titulo}
      </h3>
      <div style={{ color: 'var(--cor-texto)', fontSize: '14px', lineHeight: 1.8 }}>
        {children}
      </div>
    </div>
  )
}

export default function TermosCondicoes() {
  const [cfg, setCfg] = useState(null)
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    getConfiguracoes()
      .then(setCfg)
      .catch(console.error)
      .finally(() => setCarregando(false))
  }, [])

  if (carregando) return <div style={{ padding: '64px 24px' }}><Loading /></div>

  const nomeNegocio = cfg?.nome_negocio || 'o espaço'
  const emailContacto = cfg?.email_contacto || ''
  const textoLivre = cfg?.termos_texto || ''
  const cancelamento = cfg?.termos_cancelamento || 'As marcações podem ser canceladas ou reagendadas com pelo menos 24 horas de antecedência, através dos contactos disponibilizados. Faltas sem aviso prévio poderão estar sujeitas às condições do espaço.'
  const idade = cfg?.termos_idade || 'O serviço de marcação online destina-se a maiores de 18 anos. Os menores de 18 anos só podem efetuar marcações com o conhecimento e a autorização do respetivo representante legal, que assume a responsabilidade pelos dados fornecidos e pelo cumprimento destes termos.'
  const pagamentos = cfg?.termos_pagamentos || 'Quando aplicável, poderá ser solicitado o pagamento de um sinal no momento da marcação, processado de forma segura através da Stripe. O valor restante é liquidado no espaço. As condições de reembolso seguem a política do espaço.'
  const hoje = new Date().toLocaleDateString('pt-PT', { day: '2-digit', month: 'long', year: 'numeric' })

  return (
    <main style={{ maxWidth: '720px', margin: '0 auto', padding: '48px 24px 80px' }}>
      <Link
        to="/"
        style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px', marginBottom: '32px' }}
      >
        ← Voltar ao início
      </Link>

      <h1 style={{ fontSize: 'clamp(22px, 5vw, 30px)', marginBottom: '8px' }}>
        Termos e Condições
      </h1>
      <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginBottom: '40px' }}>
        Última atualização: {hoje}
      </p>

      <div style={{
        background: 'var(--cor-branco)',
        border: '1px solid var(--cor-borda)',
        borderRadius: 'var(--raio-lg)',
        padding: 'clamp(24px, 5vw, 40px)',
        boxShadow: 'var(--sombra)',
      }}>

        {textoLivre ? (
          <Secao titulo="Condições de Utilização">
            <p style={{ whiteSpace: 'pre-line' }}>{textoLivre}</p>
          </Secao>
        ) : (
          <>
            <Secao titulo="1. Âmbito">
              <p>
                Estes Termos e Condições regem a utilização do serviço de marcação
                online disponibilizado por <strong>{nomeNegocio}</strong>. Ao efetuar
                uma marcação, declara ter lido e aceite as presentes condições.
              </p>
            </Secao>

            <Secao titulo="2. Idade e Menores">
              <p>{idade}</p>
            </Secao>

            <Secao titulo="3. Marcações">
              <p>
                As marcações estão sujeitas a disponibilidade e só se consideram
                confirmadas após a respetiva confirmação. Os horários e serviços
                apresentados podem ser alterados sem aviso prévio.
              </p>
            </Secao>

            <Secao titulo="4. Cancelamentos e Reagendamentos">
              <p>{cancelamento}</p>
            </Secao>

            <Secao titulo="5. Pagamentos">
              <p>{pagamentos}</p>
            </Secao>

            <Secao titulo="6. Responsabilidade">
              <p>
                Comprometemo-nos a prestar os serviços com diligência e profissionalismo.
                Não nos responsabilizamos por indisponibilidades pontuais do site ou por
                informações incorretas fornecidas no momento da marcação.
              </p>
            </Secao>

            <Secao titulo="7. Proteção de Dados">
              <p>
                O tratamento dos seus dados pessoais rege-se pela nossa{' '}
                <Link to="/politica-privacidade" style={{ color: 'var(--cor-principal)' }}>
                  Política de Privacidade
                </Link>
                .
              </p>
            </Secao>

            <Secao titulo="8. Contacto">
              {emailContacto ? (
                <p>
                  Para qualquer questão relativa a estes termos, contacte-nos através
                  do email <strong>{emailContacto}</strong>.
                </p>
              ) : (
                <p>
                  Para qualquer questão relativa a estes termos, utilize os contactos
                  disponibilizados na página principal.
                </p>
              )}
            </Secao>
          </>
        )}

      </div>
    </main>
  )
}
